import { render, staticRenderFns } from "./FruitsAndVegetables.vue?vue&type=template&id=36f10355&scoped=true&"
import script from "./FruitsAndVegetables.vue?vue&type=script&lang=js&"
export * from "./FruitsAndVegetables.vue?vue&type=script&lang=js&"
import style0 from "./FruitsAndVegetables.vue?vue&type=style&index=0&id=36f10355&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f10355",
  null
  
)

export default component.exports